import { __ } from '@wordpress/i18n';

export const generalStyleTabs = [
	{ name: 'general', title: __('General', 'textdomain') },
	{ name: 'style', title: __('Style', 'textdomain') }
];

export const themeOptions = [
	{ label: 'Style 1', value: 'theme1' },
	{ label: 'Style 2', value: 'theme2' },
	{ label: 'Style 3', value: 'theme3' }
]